








import { Vue, Component, Prop, Mixins } from "vue-property-decorator";
import api from "@/lib/Api";
import TabulatorComponent from "@/components/TabulatorComponent.vue";
import GroupModalComponent from "@/components/models/GroupModalComponent.vue";
import BaseTableMixin from "@/components/layout/BaseTableMixin";

@Component({
  components: { TabulatorComponent, GroupModalComponent },
  mixins: [BaseTableMixin]
})
export default class GroupsView extends Mixins(BaseTableMixin) {
  private readonly columns: any = [
    { title: "Id", field: "Id" },
    { title: "Name", field: "Name" },
    { title: "Beschreibung", field: "Description" },
    { title: "Mitglieder", field: "Users" },
    { title: "Verantwortlich", field: "BasisUser" },
    {
      title: "EventId",
      field: "EventId",
      visible: (this as any).isSuperAdmin()
    },
    {
      title: "Uuid",
      field: "Uuid",
      visible: (this as any).isSuperAdmin(),
      headerSort: false
    }
  ];
}
